import * as tslib_1 from "tslib";
import { EventTriggerService } from '@app/event/event-trigger.service';
import { AbstractPlatform } from '@app/platform/platform';
import { SettingsService } from '@app/sync/settings.service';
import { SyncServiceBase } from '@app/sync/sync.service.base';
import { ControllerClientServiceBase } from '@app/shared/controller-client.service.base';
import { TimeService } from '@app/shared/time.service';
var ControllerClientService = /** @class */ (function (_super) {
    tslib_1.__extends(ControllerClientService, _super);
    function ControllerClientService(platform, settings, sync, timeService, eventTrigger) {
        var _this = _super.call(this, platform, settings, sync, timeService) || this;
        _this.eventTrigger = eventTrigger;
        return _this;
    }
    ControllerClientService.prototype.connect = function () {
        var _this = this;
        _super.prototype.connect.call(this);
        var connection = this.connection;
        if (!connection) {
            return;
        }
        var register = function (path, handler) {
            return connection.register(_this.url + "." + path, handler);
        };
        register('trigger_event', this.eventTrigger.triggerEventById.bind(this.eventTrigger));
    };
    return ControllerClientService;
}(ControllerClientServiceBase));
export { ControllerClientService };
